import { BaseEntity } from "#sitis/internal/models/concrete/BaseEntity";
import { Product } from "#sitis/internal/controllers/products/models/Product";
export class UserOrder extends BaseEntity {
  id;
  hash;
  externalNumber;
  externalStatus;
  externalData;
  metaData;
  orderNumber;
  orderIndex;
  parentId;
  screenId;
  createdAt;
  payedAt;
  userId;
  userCityId;
  deliveryCost;
  cost;
  note;
  status;
  statusLabel;
  paymentMethodName;
  paymentStatus;
  paymentStatusLabel;
  paymentTotal;
  cancelReason;
  customerPhone;
  customerEmail;
  customerName;
  address;
  deliveryMethodName;
  deliveryMethodClass;
  deliveryMethodId;
  deliveryIndex;
  deliveryAddress;
  deliveryTerm;
  personalDiscount;
  usedBonuses;
  cartTotalDiscount;
  paymentMethodDiscount;
  discounts;
  url;
  items;
  constructor(data) {
    super(data);
    this.url = data.url;
    this.userId = data.user_id;
    this.orderNumber = data.order_number;
    this.cancelReason = data.cancel_reason;
    this.cartTotalDiscount = data.cart_total_discount;
    this.cost = data.cost;
    this.createdAt = data.created_at;
    this.userCityId = data.user_city_id;
    this.usedBonuses = data.used_bonuses;
    this.statusLabel = data.status_label;
    this.status = data.status;
    this.seo = data.seo;
    this.screenId = data.screen_id;
    this.personalDiscount = data.personal_discount;
    this.paymentTotal = data.payment_total;
    this.paymentStatusLabel = data.payment_status_label;
    this.paymentStatus = data.payment_status;
    this.paymentMethodName = data.payment_method_name;
    this.paymentMethodDiscount = data.payment_method_discount;
    this.payedAt = data.payed_at;
    this.parentId = data.parent_id;
    this.orderIndex = data.order_index;
    this.note = data.note;
    this.metaData = data.meta_data;
    this.id = data.id;
    this.hash = data.hash;
    this.externalStatus = data.external_status;
    this.externalNumber = data.external_number;
    this.externalData = data.external_data;
    this.deliveryTerm = data.delivery_term;
    this.deliveryMethodName = data.delivery_method_name;
    this.deliveryMethodId = data.delivery_method_id;
    this.deliveryMethodClass = data.delivery_method_class;
    this.deliveryIndex = data.delivery_index;
    this.deliveryCost = data.delivery_cost;
    this.deliveryAddress = data.delivery_address;
    this.customerPhone = data.customer_phone;
    this.customerName = data.customer_name;
    this.customerEmail = data.customer_email;
    this.address = data.address ? {
      address: data.address.address,
      block: data.address.block,
      cityName: data.address.city_name,
      comment: data.address.comment,
      flat: data.address.flat,
      floor: data.address.floor,
      entrance: data.address.entrance,
      house: data.address.house,
      lat: data.address.lat,
      lon: data.address.lon,
      zip: data.address.zip,
      hasElevator: data.address.has_elevator,
      intercom: data.address.intercom,
      regionName: data.address.region_name,
      street: data.address.street,
      unrestrictedAddress: data.address.unrestricted_address,
      computedAddress: data.address.computed_address,
      elevator: data.address.elevator,
      cityId: data.address.city_id
    } : void 0;
    this.discounts = data?.discounts?.map((t) => ({
      name: t.name,
      percent: t.percent,
      type: t.type,
      value: t.value
    }));
    this.items = data?.items?.map((t) => ({
      cost: t.cost,
      data: t.data,
      discounts: t.discounts,
      orderId: t.order_id,
      id: t.id,
      externalData: t.external_data,
      externalId: t.external_id,
      discountValue: t.discount_value,
      modificationCode: t.modification_code,
      modificationId: t.modification_id,
      options: t.options,
      modificationName: t.modification_name,
      price: t.price,
      quantity: t.quantity,
      origin: t.origin,
      priceOld: t.price_old,
      product: t.product ? {
        ...new Product(t.product).toJSON()
      } : void 0,
      productCode: t.product_code,
      productId: t.product_id,
      productName: t.product_name,
      productSku: t.product_sku
    }));
  }
  toJSON() {
    return { ...this };
  }
}
